import axios from "axios";

const API = `${
  process.env.REACT_APP_API_URL || "http://localhost:5001"
}/api/hotel-feedback`;

// One month of the sheet (upload order). params: { month, q, rated, page, limit }
export const listHotelFeedbackApi = (params = {}) => axios.get(API, { params });

// [{ month: "2026-10", total, rated, pending }] newest first
export const listHotelFeedbackMonthsApi = () => axios.get(`${API}/months`);

// Save Remark's / stars / negative flag for many rows: [{ id, remarks, rating, negative }]
export const saveHotelFeedbackApi = (updates) => axios.put(API, { updates });

export const deleteHotelFeedbackApi = (id) => axios.delete(`${API}/${id}`);

export const bulkUploadHotelFeedbackApi = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return axios.post(`${API}/bulk-upload`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

// Downloads the Feedback List as .xlsx for the given filters
// ({ month: "YYYY-MM" | "all", q, rated }) — built by the server.
export const downloadHotelFeedbackExcel = async (params = {}) => {
  const res = await axios.get(`${API}/export`, { params, responseType: "blob" });
  const match = (res.headers["content-disposition"] || "").match(/filename="?([^"]+)"?/);
  const url = window.URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = match ? match[1] : "hotel-feedback.xlsx";
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
